import {
  FunctionComponent,
  useEffect,
  useState,
  useCallback,
  Fragment,
} from 'react'
import useStyles from './styles'
import { capitalize } from '@/utils/fnUtils'
import { Text } from '@conexasaude/conexa-hero'
import { DateTime } from 'luxon'
import { openWhatsappSupport } from '@/utils/openWhatsappSupport'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { RenderIf } from '../RenderIf'
import { TimeZoneLuxonProps } from './types'
import { useLocation } from 'react-router-dom'

const TimeZoneLuxon: FunctionComponent<TimeZoneLuxonProps> = ({
  showSupportLink = true,
}) => {
  const styles = useStyles()
  const [parsedDate, setParsedDate] = useState<string>('')
  const { logAnalyticsEvent } = useFirebaseContext()
  const { user } = useAuthContext()
  const { pathname } = useLocation()

  const handleSupportOpening = () => {
    logAnalyticsEvent('Pac_Login_PrecisaAjuda')
    openWhatsappSupport()
  }

  const parseDate = useCallback((date: DateTime) => {
    const parsedDate = date?.toFormat?.('dd/LL/yyyy, EEEE - HH:mm:ss')
    const timeZoneText = 'Brasil (UTC-3) - Horário de Brasília'
    return `${capitalize(parsedDate)} - ${timeZoneText}`
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      const dateTimeNow = DateTime.now().setZone('America/Sao_Paulo')

      const parseDateTimeNow = parseDate(dateTimeNow)
      setParsedDate(parseDateTimeNow)
    }, 1000)

    return () => clearInterval(interval)
  }, [parseDate])

  return (
    <Fragment>
      <Text variant="microCopy" css={styles.footer}>
        {parsedDate}
        <RenderIf
          condition={Boolean(
            user && showSupportLink && parsedDate && pathname !== '/escolha',
          )}
        >
          <Text
            renderAs="span"
            css={styles.suportLink}
            variant="linkUnderline"
            onClick={handleSupportOpening}
            cy="timezone-technical-support"
          >
            Suporte técnico
          </Text>
        </RenderIf>
      </Text>
    </Fragment>
  )
}

export default TimeZoneLuxon
